import React, { useState, useEffect } from 'react';
import { useQuery } from "react-query";
import axios from 'axios';



import { fetchDerniereAction } from 'utils/queries';

import PdfLoadingButton from '../Shared/PdfLoadingButton'

import { TypeActionCodes } from 'constants.js';

const DetailReparation = ({ reclamationId, style }) => {

    const [downloading, setDownloading] = useState(false);

    const {
        isLoading,
        error,
        data,
        //isFetching,
        //refetch,
    } = useQuery(
        ["DetailReparation", { reclamationId }],
        () => fetchDerniereAction({ reclamationId, typeActionCode : TypeActionCodes.SavDetailReparation }),
        {
            //// 🚀 only server errors will go to the Error Boundary
            //useErrorBoundary: (error) => error.response?.status >= 500,
        }
    );



    // Fetch des infos concernant  au chargement de la page
    useEffect(() => {
        const download = async () => {


            await axios.post(`api/reclamations/${reclamationId}/exporter-documentDetailReparation`, {}, { responseType: 'blob' })
                .then(function (response) {

                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;

                    const contentDisposition = response.headers['content-disposition'];

                    const regex = new RegExp("filename[^;=\\n]*=['\"]?(?:UTF-\\d['\"]*)?([^;\\r\\n\"']*)['\"]?;?"); // https://stackoverflow.com/questions/23054475/javascript-regex-for-extracting-filename-from-content-disposition-header

                    const match = regex.exec(contentDisposition);

                    const filename = match[1]; // On prend le groupe 1

                    link.setAttribute('download', decodeURIComponent(filename));

                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                })
                .catch((error) => {
                    console.log(error);
                    //this.setState({ erreurDocRepriseMarchandiseIncidentLivraison: true });
                })
                .then(() => {
                    // always executed
                    //this.setState({ loadingDocRepriseMarchandiseIncidentLivraison: false });

                    setDownloading(false);
                });


        };


        if (downloading) {
            download();
        }

    }, [reclamationId, downloading]);



    if (isLoading) {
        return null;
    }

    if (error) {
        return (<p>Erreur de contrôle de la présence d'une action de détail réparation, veuillez contacter le support !</p>);
    }

    if (!data) {
        return null;
    }

    return <PdfLoadingButton
        disabled={false}
        onClick={e => setDownloading(true)}
        label={"Détail réparation"}
        pending={downloading}
        style={style}/>
}



export default DetailReparation;